export default function HTag({show,tag,children}) {
    
    var vartag = {h1: <h1>{children}</h1>,
                  h2: <h2>{children}</h2>,
                  h3: <h3>{children}</h3>
                 }[tag] || <h1>{children}</h1>

    if (show) return (vartag)
    return children
}